import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../ui/alert-dialog";

function describeConfirm(confirm) {
  if (!confirm) return { title: "", body: "" };
  if (confirm.kind === "category" && confirm.count > 0) {
    return {
      title: `Delete ${confirm.name}?`,
      body: `${confirm.count} product${confirm.count > 1 ? "s" : ""} still use this category. Reassign them first.`,
    };
  }
  return {
    title: `Delete ${confirm.name}?`,
    body: "This only removes it from the catalog. Existing requests are kept.",
  };
}

// Confirmation dialog for product, supplier and category deletion.
export default function CatalogConfirmDialog({ confirm, onCancel, onConfirm }) {
  const { title, body } = describeConfirm(confirm);
  return (
    <AlertDialog open={!!confirm} onOpenChange={(o) => !o && onCancel()}>
      <AlertDialogContent className="bg-[#FBF8F1] border-[#E6E0D4]">
        <AlertDialogHeader>
          <AlertDialogTitle className="font-serif-display text-[#0B1F3A]">{title}</AlertDialogTitle>
          <AlertDialogDescription>{body}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction className="bg-[#0B1F3A] hover:bg-[#11294A] text-white" onClick={onConfirm}>
            Delete
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
